import { useMemo } from 'react';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { useApplicationType } from './use-application-type';

export function useMappedShortcutKeyViews() {
    const shortcutKeyViews = useBootstrapState().shortcutKeyViews;
    const { isFirstResponder } = useApplicationType();

    return useMemo(() => {
        const filteredShortcuts = isFirstResponder
            ? shortcutKeyViews.filter(
                  (shortcutKeyView) => shortcutKeyView.shortcutContext === 'FIRST_RESPONDER'
              )
            : shortcutKeyViews.filter(
                  (shortcutKeyView) =>
                      shortcutKeyView.shortcutContext === 'DISPATCHER' ||
                      shortcutKeyView.shortcutContext === 'DISPATCHER_EVENT_PANEL' ||
                      shortcutKeyView.shortcutContext === 'DISPATCHER_EVENT_WINDOW'
              );
        return filteredShortcuts.map((shortcutKeyView) => ({
            ...shortcutKeyView,
            // our backend sends down "meta" for the mod key, but our library expects "mod",
            // so we do a simple replace
            mappedShortcutKeyCombination: shortcutKeyView.shortcutKeyCombination.replace(
                'meta',
                'mod'
            ),
        }));
    }, [shortcutKeyViews, isFirstResponder]);
}
